import apiClient from './client';
import type { OAuthAccount } from '../types';

export async function getOAuthAccounts(): Promise<OAuthAccount[]> {
  const response = await apiClient.get<OAuthAccount[]>('/user/oauth/accounts');
  return response.data;
}

export async function linkGoogleAccount(redirectUrl: string = '/settings'): Promise<{ auth_url: string }> {
  const response = await apiClient.post<{ auth_url: string }>('/user/oauth/google/link', {
    redirect_url: redirectUrl,
  });
  return response.data;
}

export async function unlinkGoogleAccount(): Promise<{ message: string }> {
  const response = await apiClient.delete<{ message: string }>('/user/oauth/google');
  return response.data;
}

